import script from "./ConfigurationRadioSelectionV4.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationRadioSelectionV4.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationRadioSelectionV4.vue?vue&type=style&index=0&id=c3a39f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a39f3e"]])

export default __exports__